const springBootApiBaseUrl = process.env.REACT_APP_SPRING_BOOT_API_URL;
const MOCK_AUTH_MODE = String(process.env.REACT_APP_AUTH_MODE) !== "ms_entra_id";

export type Tool = {
    infoUrl?: string;
    releaseDate?: string;
    isReleased?: boolean;
    code: string;
    name: string;
    blurb: string;
    longBlurb?: string;
    priceDisplay: string;
    priceId?: string | null;
    subscribed: boolean; // derived per user
    status: string;      // "active" | "none" | "past_due" | ...
    unitName?: string;
};

export async function getTools(token?: string | null): Promise<{ tools: Tool[]; mockAuthMode: boolean }> {
    if (MOCK_AUTH_MODE) {
        return {
            mockAuthMode: true,
            tools: [
                { code: "OPTIMIZATION_INGEST_SCHEDULER", name: "Optimization Ingest Scheduler", blurb: "Normalize NR metrics", priceDisplay: "$49/mo", priceId: "price_NRTB_DUMMY", subscribed: true, status: "active", isReleased: false, releaseDate: "2025-09-29" },
                { code: "TRACE_TOGGLE", name: "Trace Toggle", blurb: "Toggle Sending Spans to New Relic", priceDisplay: "$49/mo", priceId: "price_TRACE_TOGGLE_DUMMY", subscribed: true, status: "active", isReleased: false, releaseDate: "2025-09-29" },
                { code: "DROP_RULES", name: "Drop Rules", blurb: "Allows dropping of tables on a tenant level", priceDisplay: "$10/mo", priceId: "price_DROP_DUMMY", subscribed: false, status: "none", isReleased: false, releaseDate: "2025-09-29" },
            ],
        };
    }

    const headers: Record<string, string> = {};

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const r = await fetch(`${springBootApiBaseUrl}/api/tools`, {
        headers: headers,
    });
    if (!r.ok) throw new Error(`/api/tools failed: ${r.status}`);
    const tools = await r.json(); // backend returns ToolDto[]
    return { tools, mockAuthMode: false };
}

export async function startCheckout(priceId: string, quantity: number, token?: string): Promise<string | null> {
    if (MOCK_AUTH_MODE) return null;
    const r = await fetch(`${springBootApiBaseUrl}/api/billing/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ priceId, quantity }),
    });
    if (!r.ok) throw new Error(`Checkout failed: ${r.status}`);
    return await r.text();
}

export async function openPortal(token?: string): Promise<string | null> {
    if (MOCK_AUTH_MODE) return null;
    const r = await fetch(`${springBootApiBaseUrl}/api/billing/portal`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
    });
    if (!r.ok) throw new Error(`Portal failed: ${r.status}`);
    return await r.text();
}
